import { useEffect, useState, type JSX } from 'react';

import { ApiFehler } from '../api/fehler';
import { amTermin, type StandAmTermin } from '../api/warteliste';
import { Meldung } from '../komponenten/Meldung';

/**
 * DIE WARTELISTE AM TERMIN (BUC-11 nach ÄA-55).
 *
 * Die Liste selbst steht am Training (Artikelakte, Reiter „Programm"). Hier
 * steht nur, wie viele bestätigte Einträge zu DIESEM Termin passen — Zeitraum
 * deckt den Beginn, Plätze passen in die Kapazität — und wie viele davon
 * schon eine Mail zu ihm bekommen haben. Wer am Telefon über eine höhere
 * Kapazität entscheidet, sieht so, ob sie jemandem nützt.
 */
export function Wartelistenkarte({ termin }: { readonly termin: string }): JSX.Element {
  const [stand, setzeStand] = useState<StandAmTermin | undefined>(undefined);
  const [fehler, setzeFehler] = useState<ApiFehler | null>(null);

  useEffect(() => {
    let verworfen = false;
    void amTermin(termin)
      .then((s) => {
        if (!verworfen) {
          setzeStand(s);
          setzeFehler(null);
        }
      })
      .catch((e: unknown) => {
        if (!(e instanceof ApiFehler)) throw e;
        if (!verworfen) setzeFehler(e);
      });
    return () => {
      verworfen = true;
    };
  }, [termin]);

  return (
    <div className="warteliste">
      <h3>Warteliste</h3>
      {fehler !== null && <Meldung fehler={fehler} />}
      {stand === undefined && fehler === null && <p role="status">Wird geladen …</p>}
      {stand !== undefined && (
        <p className="hilfe">
          {stand.eintraege === 0
            ? 'Auf diesen Termin passt kein bestätigter Eintrag.'
            : `${String(stand.eintraege)} ${stand.eintraege === 1 ? 'Eintrag passt' : 'Einträge passen'} `
              + `zu diesem Termin, zusammen ${String(stand.plaetze)} `
              + `${stand.plaetze === 1 ? 'Platz' : 'Plätze'}; `
              + `${String(stand.benachrichtigt)} davon schon benachrichtigt.`}
        </p>
      )}
      <p className="feld__hilfe">Die Einträge selbst stehen am Training, im Reiter „Programm".</p>
    </div>
  );
}
